import React, { Component } from 'react';
import _ from 'lodash';

import { Department } from '../../../views/Department';

import { StyledTitleDepartment } from './style';

import {
  getDepartmentData,
  getDepartmentDocs,
  getDepartmentTeam
} from '../../../../utils/apiDepartment';
import Loading from '../../../core/Loading';
import { getUserDetails } from '../../../../utils/apiUser';
import { getSubDepartments } from '../../../../utils/apiDataUserForm';
import { parseSelect } from '../../../../utils/parseSelect';

class GeneralInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      docs: undefined,
      nameFromRoute: undefined,
      loading: true,
      title: undefined
    };
  }

  componentDidMount() {
    const { match } = this.props;

    document.body.style.overflow = 'unset';
    this.getData(match.params.id, match.url);
  }

  componentWillReceiveProps(nextProps) {
    const { match } = this.props;

    if (nextProps.match.params.id !== match.params.id) {
      this.state = {
        loading: true
      };
      this.getData(nextProps.match.params.id, nextProps.match.url);
    }
  }

  getData = (id, url) => {
    const nameFromRoute = url.substring(url.lastIndexOf('/') + 1);
    Promise.resolve(getUserDetails()).then(result => {
      const {
        userProfile: { idSubDepartment, idArea }
      } = result;
      getSubDepartments(idSubDepartment).then(areas => {
        if (idArea) {
          const areaSelected = parseSelect(areas).filter(
            area => area.value === idArea.toString()
          );
          if (areaSelected && areaSelected.length > 0) {
            this.setState({
              title: areaSelected[0].text
            });
          }
          Promise.all([
            getDepartmentDocs(id),
            getDepartmentData(id),
            getDepartmentTeam(id)
          ])
            .then(result => {
              this.setState({
                docs: _.orderBy(
                  result[0],
                  doc => doc.fileName.toLowerCase(),
                  'asc'
                ),
                data: result[1],
                team: this.convertDataModelTeam(idArea, result[2])
              });
            })
            .catch(error => {
              throw error;
            })
            .finally(() => {
              this.setState({
                loading: false,
                nameFromRoute
              });
            });
        }
      });
    });
  };

  convertDataModelTeam = (idArea, data) => {
    const result = {};
    result.dataTeam = data
      .filter(el => el.idArea === idArea)
      .map(el => ({
        ...el,
        person: `${el.name} ${el.lastname}`,
        job: el.profile
      }));
    result.title = 'Nuestro equipo';
    return result;
  };

  render() {
    const { data, nameFromRoute, docs, team, loading, title } = this.state;
    if (!data || !nameFromRoute || !docs) {
      return null;
    }
    const { extension, telephone, address, email } = data;

    return loading ? (
      <Loading size="xl" />
    ) : (
      <React.Fragment>
        <StyledTitleDepartment>{title || data.name}</StyledTitleDepartment>
        <Department
          ourTeam={team}
          dataUser={{
            extension,
            telephone,
            address,
            email
          }}
        >
          {data.description && <div>{data.description}</div>}
        </Department>
      </React.Fragment>
    );
  }
}

export default GeneralInformation;
